import * as React from 'react';

import FormElement from 'components/FormElement';
import Input from 'components/Input';
import assertions from 'lib/assertions';

// @ts-ignore
import { AUTO_MESSAGE_NAME_CHAR_LIMIT } from './AdminNewAutoMessageCreate';

type Props = {
  defaultValue?: string;
  handleMessageNameChange: (messageName?: string) => void;
};

export default function AdminNewAutoMessageComposeMessageName(props: Props) {
  const { defaultValue, handleMessageNameChange } = props;
  return (
    <FormElement
      data-test="message-name-input"
      showErrorBeforeBlur
      label="Message name"
      onValidChange={(e: React.ChangeEvent<HTMLInputElement>) => handleMessageNameChange(e.target.value)}
      onInvalidChange={() => handleMessageNameChange(undefined)}
      subtext="Give this auto message a name that is easily distinguishable. Message names are only
                visible to you and other administrators."
      validate={(e: React.ChangeEvent<HTMLInputElement>) => {
        assertions.lengthLesserThanOrEqualTo(
          e.target.value,
          AUTO_MESSAGE_NAME_CHAR_LIMIT,
          `Please provide a message name under ${AUTO_MESSAGE_NAME_CHAR_LIMIT} characters long.`
        );
      }}
      element={Input}
      elementProps={{
        defaultValue,
        placeholder: '1st Period Attendance, Weekly Lunch Money Balance, Overdue Library Books',
        name: 'messageName',
      }}
    />
  );
}
